import React from 'react';
import data from './data';
import ProjectItem from './ProjectItem';

const Projects = () => data.length > 0 && <div className="timeline-container" />;

export default Projects;
